module.exports = __webpack_public_path__ + "img/store.346c42bd.png";